// extracted by mini-css-extract-plugin
export var tosLink = "_84-0";